<div class="event-acceptation">
  <div class="container h-100">
    <div *ngIf="event" class="event-acceptation-wrapper">
      <div class="event-acceptation-item-wrapper">
        <div class="event-acceptation-item">
          <div class="white-board-logo text-center">
            <img draggable="false" src="/assets/img/logo.svg" alt="intilio" />
          </div>

          <div class="event-acceptation-item__title mb-3">
            {{ event?.name }}
          </div>

          <div *ngIf="event?.project?.fullName" class="event-acceptation-item__text mb-3">
            <strong>{{ 'EventNotification.project' | translate }}</strong>
            <p>{{ event?.project?.fullName }}</p>
          </div>

          <div class="event-acceptation-item__text mb-3">
            <strong>{{ 'EventNotification.date' | translate }}</strong>
            <p>{{ event?.termStart | rangeFormat: event?.termEnd }}</p>
          </div>

          <div *ngIf="event?.creator?.userPerson" class="event-acceptation-item__text mb-3">
            <strong>{{ 'EventNotification.creator' | translate }}</strong>
            <p>{{ event?.creator?.userPerson?.fullName }}</p>
          </div>

          <div *ngIf="event?.address" class="event-acceptation-item__text mb-3">
            <strong>{{ 'EventNotification.location' | translate }}</strong>
            {{ event?.address }}
          </div>

          <!-- <div class="event-acceptation-item__date mb-1 text-capitalize">
            {{ event?.termStart | rangeFormat: event?.termEnd }}
          </div> -->

          <!-- <div class="mb-1" *ngIf="event?.project">
            <div>
              <b>{{ 'CalendarEvents.project' | translate }}:</b>
            </div>
            <div
              (click)="previewProject()"
              class="calendar-event-popover__content-text text-primary pointer"
              [title]="event?.project?.fullName"
            >
              {{ event?.project?.fullName }}
            </div>
          </div> -->

          <!-- <div *ngIf="event?.creator?.userPerson" class="event-acceptation-item__creator mb-1">
            {{ 'CalendarEvents.creator' | translate }}
            <b class="text-dark"> {{ event?.creator?.userPerson?.fullName }}</b>
          </div> -->

          <!-- <div class="event-acceptation-item__address">
            {{ event?.address }}
          </div> -->

          <div class="pt-5 d-flex">
            <app-button
              [class]="'mr-2 bold'"
              [disabled]="pending"
              (onClick)="eventRejection()"
              [config]="{
                text:
                  (event?.myParticipation?.status === EAttendance.REJECTED
                    ? 'EventNotification.declined'
                    : 'EventNotification.decline'
                  ) | translate,
                size: ButtonSize.SMALL,
                type:
                  event?.myParticipation?.status === EAttendance.REJECTED
                    ? ButtonTypes.DANGER_BUTTON
                    : ButtonTypes.NEW_SECONDARY_BLUE,
                prependSrc:
                  event?.myParticipation?.status === EAttendance.REJECTED ? './assets/img/ic-close.svg' : ''
              }"
            />

            <app-button
              [class]="'bold'"
              [disabled]="pending"
              (onClick)="eventAcceptation()"
              [config]="{
                text:
                  (event?.myParticipation?.status === EAttendance.CONFIRMED
                    ? 'EventNotification.accepted'
                    : 'EventNotification.accept'
                  ) | translate,
                size: ButtonSize.SMALL,
                type:
                  event?.myParticipation?.status === EAttendance.CONFIRMED
                    ? ButtonTypes.NEW_PRIMARY_GREEN
                    : ButtonTypes.NEW_SECONDARY_BLUE,
                prependSrc:
                  event?.myParticipation?.status === EAttendance.CONFIRMED
                    ? './assets/img/tick-white.svg'
                    : './assets/img/calendar-blue.svg'
              }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
